export const initialValues = {
	email: "",
	password: "",
	password_confirmation: "",
};
